module.exports = {
          srcSet: __webpack_public_path__ + "public/images/157fa6d0f38d443438c4663b2eb56892-1774.jpg"+" 1774w",
          images:[ {path: __webpack_public_path__ + "public/images/157fa6d0f38d443438c4663b2eb56892-1774.jpg",width: 1774,height: 887}],
          src: __webpack_public_path__ + "public/images/157fa6d0f38d443438c4663b2eb56892-1774.jpg",
          toString:function(){return __webpack_public_path__ + "public/images/157fa6d0f38d443438c4663b2eb56892-1774.jpg"},
          
          width: 1774,
          height: 887
        }